import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';


export class EditElementModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleFormSubmitted(dataSubmitted) {
        this.toggle();
        this.props.onFormSubmitted(dataSubmitted);
    }

    renderButton() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderModalHeaderText() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderModalForm() {
        throw new Error('This method must be overridden in the concrete component.');
    }

    renderCloseWithCaution() {
        if(this.props.clickOutsideDontCloseModal !== undefined && this.props.clickOutsideDontCloseModal === true) {
            return "static";
        }
    }

    render() {
        return (
            <div className="button-for-modal" style={this.props.style}>
                {this.renderButton()}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop={this.renderCloseWithCaution()}>
                    <ModalHeader toggle={this.toggle}>{this.renderModalHeaderText()}</ModalHeader>
                    {this.renderModalForm()}
                </Modal>
            </div>
        );
    }
}
